export enum ServicePlanTiers {
    BASIC = "Basic",
    INTERACTIVE = "Interactive",
    INTERACTIVE_PLUS = "Interactive Plus",
    INTERACTIVE_PLUS_LTE = "Interactive Plus LTE",
}
export const SERVICE_PLAN_TIERS = Object.values(ServicePlanTiers);

export enum SERVICE_PLAN_DIALOG_VIEW {
    SELECT_PLAN,
    COMPARE_PLANS,
}
